module.exports = __webpack_public_path__ + "static/media/ha.55273355.png";